export default __webpack_public_path__ + "static/media/world.fc147329.svg";